import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M8.058 5.908a.41.41 0 0 0-.41-.41h-1.74a.41.41 0 0 0-.41.41v12.18c0 .226.184.41.41.41h1.74a.41.41 0 0 0 .41-.41zm1.5 12.18a1.91 1.91 0 0 1-1.91 1.91h-1.74a1.91 1.91 0 0 1-1.91-1.91V5.908a1.91 1.91 0 0 1 1.91-1.91h1.74a1.91 1.91 0 0 1 1.91 1.91zM18.499 5.908a.41.41 0 0 0-.41-.41h-1.74a.41.41 0 0 0-.41.41v12.18c0 .226.184.41.41.41h1.74a.41.41 0 0 0 .41-.41zm1.5 12.18a1.91 1.91 0 0 1-1.91 1.91h-1.74a1.91 1.91 0 0 1-1.91-1.91V5.908a1.91 1.91 0 0 1 1.91-1.91h1.74A1.91 1.91 0 0 1 20 5.908z"
    }, null, -1)
  ]))]))
}
export default { render: render }